import _ from "lodash";
import {
	byId,
	getParents,
	getSpecificityById,
	getSpecificityType
} from "@/helper/application/characteristic/Provider";
import * as CharacteristicType from "@/helper/characteristic/Type";
import {camelize} from "@/helper/String";
import {isDefined} from "@/helper/Value";

export function characteristicMultiple (list, meta, metaItems, metaType, withParents)
{
	let newList = [];

	_.forEach(list, item =>
	{
		const populatedItem = characteristicSingle(item, meta, metaItems, metaType);

		if (populatedItem.item)
		{
			// if not yet in
			if (!_.find(
				newList,
				item => item.item?.id === populatedItem.item.id)
			)
			{
				newList.push(populatedItem);
			}
		}
		else // free text, just add
		{
			newList.push(populatedItem);
		}

		if (withParents && populatedItem.item)
		{
			const parents = getParents(populatedItem.item.id, metaItems);

			if (parents)
			{
				_.forEach(parents, parent =>
				{
					const alreadyIn = isDefined(
						_.find(newList, item => item.item.id === parent.id)
					);

					if (!alreadyIn)
					{
						newList.push({
							item: parent
						});
					}
				});
			}
		}
	});

	return newList;
}

export function characteristicSingle (item, meta, metaItems, metaType)
{
	// could be we are already getting the item
	if (item.item && typeof item.item === 'string')
	{
		item.item = byId(item.item, metaItems);
	}
	else if (item.item && typeof item.item === 'object')
	{
		// always reload from meta, so we have all children, tags, etc. in the item
		item.item = byId(item.item.id, metaItems);
	}

	if (item.specificities)
	{
		_.forEach(item.specificities || [], specificityItem =>
		{
			specificityItem.specificityType = specificityItem.specificityType
				? (typeof specificityItem.specificityType === 'string'
					? getSpecificityType(specificityItem.specificityType, metaType)
					: specificityItem.specificityType)
				: null;

			if (typeof specificityItem.specificity === 'string')
			{
				specificityItem.specificity = getSpecificityById(
					specificityItem.specificity,
					metaItems,
					specificityItem.specificityType
				);
			}
		});
	}

	if (item.supplements)
	{
		_.forEach(item.supplements, supplementGroup =>
		{
			supplementGroup.characteristicType = typeof supplementGroup.characteristicType === 'string'
				? CharacteristicType.getById(supplementGroup.characteristicType, meta)
				: supplementGroup.characteristicType;

			_.forEach(supplementGroup.items, item =>
			{
				if (typeof item.item === 'string')
				{
					item.item = byId(item.item, meta[camelize(supplementGroup.characteristicType.id)])
				}
			});
		});
	}

	if (item.experience)
	{
		item.experience = typeof item.experience === 'string'
			? byId(item.experience, meta.workExperience)
			: item.experience;
	}

	if (item.selfAssessment)
	{
		item.selfAssessment = typeof item.selfAssessment === 'string'
			? byId(item.selfAssessment, meta.skillSelfAssessment)
			: item.selfAssessment;
	}

	return item;
}
